const {Sign} = require( './Sign')
const {Schedule} = require( './Schedule')

/**
 * Model for LocalSettings
 */
class LocalSettings {
    /**
     * @param {number} pageCount
     * @param {boolean} signsJustPasted
     * @param {[Sign]} copiedSigns
     * @param {boolean} taskJustPasted
     * @param {[Task]} copiedTask
     */
    constructor(
        pageCount=10,
        signsJustPasted=true,
        taskJustPasted=true,
        copiedSigns=[],
        copiedTask=[],
    ) {
        this.page_count = pageCount

        this.signs_just_pasted = signsJustPasted
        this.copied_signs = copiedSigns
        this.last_time_copied_signs = new Date()

        this.task_just_pasted = taskJustPasted
        this.copied_task = copiedTask
        this.last_time_copied_task = new Date()
    }

    /**
     * @param {any} json
     * @return {Settings}
     */
    static from(json) {
        const settings = Object.assign(new LocalSettings(), json)
        settings.last_time_copied_signs = new Date(settings.last_time_copied_signs)
        settings.last_time_copied_task = new Date(settings.last_time_copied_task)
        const now = new Date()
        if ((now - settings.last_time_copied_signs) / (60 * 1000) > 10) {
            settings.copied_signs = []
        }
        if ((now - settings.last_time_copied_task) / (60 * 1000) > 10) {
            settings.copied_task = []
        }
        return settings
    }

    /**
     * Gets the settings from the storage
     * @return {Settings}
     */
    static fromStorage() {
        return LocalSettings.from(
            JSON.parse(localStorage.getItem('localSettings')))
    }

    /**
     * @param {string} varName
     * @param {number} value
     */
    update(varName, value) {
        this[varName] = value

        localStorage.setItem('localSettings', JSON.stringify(this))
    }

    /**
     * @return {[Sign]}
     */
    pasteSigns() {
        this.signs_just_pasted = true
        let signs = []
        for (let i = 0; i < this.copied_signs.length; i++) {
            signs.push(Sign.from(this.copied_signs[i]))
        }
        this.update('signs_just_pasted', true)
        this.update('last_time_copied_signs', new Date())
        return signs
    }

    /**
     * @param {sign} sign
     */
    copySign(sign) {
        if (this.signs_just_pasted) {
            this.signs_just_pasted = false
            this.copied_signs = []
        }
        this.copied_signs.push(sign)
        this.update('copied_signs', this.copied_signs)
        this.update('last_time_copied_signs', new Date())
    }

    /**
     * @return {[Task]}
     */
    pasteTask() {
        this.task_just_pasted = true
        let task = []
        for (let i = 0; i < this.copied_task.length; i++) {
            const pasted = Schedule.from(this.copied_task[i])
            // Per-occurrence execution state (who/when *this* task
            // instance was worked), not part of the reusable task
            // definition - stripped here at paste time (not at copy
            // time) so the clipboard itself still holds the full
            // original object, in case a future feature wants to look
            // at the copy as a complete snapshot for other purposes.
            pasted.is_complete = false
            pasted.start_time = null
            pasted.end_time = null
            pasted.started_by = null
            pasted.completed_by = null
            task.push(pasted)
        }
        this.update('task_just_pasted', true)
        this.update('last_time_copied_task', new Date())
        return task
    }

    /**
     * @param {Task} task
     */
    copyTask(task) {
        task = JSON.parse(JSON.stringify(task))
        task.id = null
        task.dependency = []
        if (this.task_just_pasted) {
            this.task_just_pasted = false
            this.copied_task = []
        }
        this.copied_task.push(task)
        this.update('copied_task', this.copied_task)
        this.update('last_time_copied_task', new Date())
    }
}

module.exports = {
    LocalSettings,
}
